import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    role: {},
    error: ''
};

const registerSlice = createSlice({
    name: 'Role',
    initialState,
    reducers: {
        setSelectedRole(state: any, action: any) {
            state.role = action.payload;
        },
        resetSelectedRole(state: any) {
            state.role = {};
        },
        roleSelectError(state:any, action:any){
            state.role = {};
            state.error = action.payload
        }
    }
});

export const { setSelectedRole, resetSelectedRole , roleSelectError} = registerSlice.actions;
export default registerSlice.reducer;
